/* Top level history page. This page should get all titles from MongoDB and show them. Upon
   clicking on a title, a component should then show that entry. That component should be
   re-used on any page where a history entry needs to be shown. */

import React, { useEffect, useState }  from 'react'
import axios                           from 'axios'
import Box                             from "@material-ui/core/Box"
import { CLIENT_PUBLIC_TOKEN }         from '../config.js'
import Grid                            from "@material-ui/core/Grid"
import { node_server }                 from '../Helpers/index.js'
import PropTypes                       from 'prop-types'
import Typography                      from "@material-ui/core/Typography"

import HistoryReadComponent            from './HistoryReadComponent.js'

const HistoryTitles = ( { handleClick, id, page } ) => {

   const [ displayTitles,  setDisplayTitles  ]  =  useState([])
   // const [ id,             setId             ]  =  useState('')

   /* This shows the available Historical Entry Titles from the history collection in MongoDB.
      Clicking on a title will then open the <HistoryReadComponent /> for that entry. */
   useEffect(() => {
      console.log('HistoryTitles useEffect is running')
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'history/getAllTitles')
         .then( res => res.data )
         .then( data => {
            setDisplayTitles(data.map( d => {
               return(
               <Grid key={d._id} >
                  <Typography key={d._id} variant='h6' align='left' onClick={() => handleClick(d._id)} >
                     { d.title }
                  </Typography>
                  {id === d._id && page === 'History'
                     ?
                        <HistoryReadComponent id={id} />
                     :
                        null
                  }
               </Grid>
               )
            }))
         })
         .catch( ( error, msg ) => {
            console.error('error and msg are', error, msg)
         } )

   }, [id] )

   return (
      <Box>
         <Grid style={{ marginTop: '6rem', marginLeft: '3rem' }} >
            { displayTitles }
         </Grid>
      </Box>
   )
}

HistoryTitles.propTypes = {
  handleClick: PropTypes.func,
  id:          PropTypes.object,
  page:        PropTypes.string
}

export default HistoryTitles
